export function CgcwFooter (): JSX.Element {
  return (
    <div>
      <div>©{new Date().getFullYear()} CGCW</div>
      <div>43 Belmont Street, Worcester, MA 01605</div>
    </div>
  )
}
